import { apiWithHeader} from "./api";
import { BASE_URL } from "./environment";

export const putApiCall = async (url) => {
  const CONTENT_TYPE = "application/json";
  return apiWithHeader(BASE_URL, CONTENT_TYPE)
    .put(url)
    .catch(function (error) {
      return error.response;
    });
};
